<template>
  <div class="c-comment">
    <div>
      <figure class="c-comment__figure me-4">
        <img
          :src="body.author.avatar
            ? body.author.avatar
            : require('@/assets/img/profile/user.png')"
          alt=""
          class="w-100 h-100 of--cover">
      </figure>
    </div>
    <div class="w-100">
      <template v-if="!isEditable">
        <div class="d-flex justify-content-between">
          <div>
            <h2 class="fs-18 gray-lightx w-medium mb-0">
              {{body.author.first_name}}
              {{body.author.last_name}}
            </h2>
            <p class="fs-14 sec-light w-regular mb-0">
              {{body.date}}
            </p>
          </div>

          <div v-if="body.author.id === userData.id">
            <b-dropdown
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              text
              right
            >
              <template #button-content class="outline-none">
                <span class="fs-18 sec-light">
                  <Icon
                    icon="simple-line-icons:options-vertical"
                    class="d-flex"/>
                </span>
              </template>
              <b-dropdown-item
                href="#"
                @click="isEditable = true"
              >
                <p
                  class="d-flex sec-medium fs-16 w-regular mb-0
                    align-items-center">
                  <span class="d-flex me-2 fs-18">
                    <Icon icon="nimbus:pencil"/>
                  </span>
                  Editar
                </p>
              </b-dropdown-item>
              <b-dropdown-item
                href="#"
                @click="openDelete()"
              >
                <p
                  class="d-flex alerts fs-16 w-regular mb-0
                    align-items-center">
                  <span class="d-flex me-2 fs-18">
                    <Icon icon="fa6-regular:trash-can"/>
                  </span>
                  Eliminar
                </p>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="mb-3">
          <p class="sec-lightx fs-16 w-regular">
            {{body.comment_content}}
          </p>
          <button
            @click="isEnableEditor = true"
            class="pri-color bg-sec-color border-0
              d-flex align-items-center mb-3"
          >
            <span class="fs-21 d-flex me-2">
              <Icon icon="bx:message"/>
            </span>
            Responder
          </button>

          <Editor
            v-if="isEnableEditor"
            type="answer"
            mode="post"
            :parent="Number(body.comment_ID)"
            :toggle.sync="isEnableEditor"
          />
        </div>
      </template>
      <template v-else>
        <Editor
          type="comment"
          mode="update"
          :content="body.comment_content"
          :commentId="Number(body.comment_ID)"
          :toggle.sync="isEditable"
        />
      </template>

      <div v-if="isVisibleAnswers" class="row gy-3">
        <div
          v-for="answer of body.answers"
          :key="`answer-${answer.comment_ID}`"
          class="col-12 ps-0"
        >
          <Answer :body="answer" />
        </div>
      </div>

      <a
        href=""
        v-if="body.answers.length && !isVisibleAnswers"
        @click.prevent="showAnswers()"
        class="c-link c-link--primary flat d-flex align-items-center justify-content-start"
      >
        <span class="fs-18 d-flex me-2">
          <Icon icon="akar-icons:chevron-down"/>
        </span>
        Ver respuestas
      </a>

      <a
        href="#"
        v-if="body.answers.length >= 10 && isVisibleAnswers && paged >= 2"
        @click.prevent="getAnswers()"
        class="c-link c-link--primary flat d-flex align-items-center justify-content-start"
      >
        <span class="fs-21 d-flex me-2">
          <Icon icon="clarity:child-arrow-line"/>
        </span>
        Cargar más respuestas

        <span v-if="isLoading" class="ms-2">
          <Icon icon="eos-icons:loading" />
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      paged: 2,
      isVisibleAnswers: false,
      isEditable: false,

      isEnableEditor: false,
      isLoading: false,
    };
  },
  props: {
    body: Object,
  },
  components: {
    Editor: () => import(/* webpackChunkName: "editor" */'./Editor.vue'),
    Answer: () => import(/* webpackChunkName: "answer" */'./Answer.vue'),
  },
  computed: {
    baseLectionRest() {
      return `${process.env.VUE_APP_API}/courses/${this.$route.params.course_id}/modules/${this.$route.params.module_id}/lections/${this.$route.params.lection_slug}`;
    },
    userData() {
      return this.$store.getters.stateUser;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },
  },
  methods: {
    ...mapActions(['fillAnswers', 'initSelectedComment']),

    showAnswers() {
      this.isVisibleAnswers = true;
    },
    getAnswers() {
      if (!this.isLoading) {
        this.isLoading = true;

        const request = `${this.baseLectionRest}/comments/${this.body.comment_ID}/answers?paged=${this.paged}`;

        fetch(request, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.userAuthToken}`,
          },
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((response) => {
            if (response.status) {
              this.fillAnswers({
                commentId: Number(this.body.comment_ID),
                data: this.body.answers.concat(response.data),
              });

              this.paged += 1;
            } else {
              this.paged = -1;
            }
          })
          .catch((err) => {
            this.paged = -1;

            throw err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    openDelete() {
      this.initSelectedComment({
        type: 'comment',
        commentId: Number(this.body.comment_ID),
      });

      this.$bvModal.show('modalDelete');
    },
  },
};
</script>
